export default {
	ADD_FILE: 'Add File',
	DISABLED: 'Disabled',
};